import { lazy } from 'react';
import { ItemRoute } from '@/app/common/types/commonTypes';

// Lazy load components for code splitting
const Layout = lazy(() => import('../layout/Layout'));
const Home = lazy(() => import('@/app/home/pages/Home'));
const NotFound = lazy(() => import('@/app/common/notfound/pages/NotFound'));
const ContactUs = lazy(() => import('@/app/common/communication/contact-us/pages/ContactUs'));

// Lazy load route configurations
export const loadRoutes = async () => {
  const { getHomeRoutesConfig } = await import('./homeRoutes');
  const { authRoutes } = await import('@/app/auth/routes/authRoutes');
  const { toolRoutes } = await import('@/app/common/tools/routes/toolRoutes');
  const { communicationPaths } = await import('@/app/common/communication/routes/communicationPaths');

  const homeRoutesConfig = await getHomeRoutesConfig();

  return {
    homeRoutesConfig,
    authRoutes,
    toolRoutes,
    communicationPaths
  };
};

// Create routes dynamically
export const createRoutes = (routesData: Awaited<ReturnType<typeof loadRoutes>>): ItemRoute[] => [
  {
    path: '/',
    element: Layout,
    children: [
      {
        path: '/',
        element: Home,
        children: routesData.homeRoutesConfig,
      },
    ],
  },
  ...routesData.authRoutes,
  ...routesData.toolRoutes,
  { path: routesData.communicationPaths.contactUs.path, element: ContactUs },
  { path: '*', element: NotFound },
];

// Initialize routes - this will be called from AppContent
let cachedRoutes: ItemRoute[] | null = null;

export const getAllRoutes = async (): Promise<ItemRoute[]> => {
  if (cachedRoutes) {
    return cachedRoutes;
  }
  const routesData = await loadRoutes();
  cachedRoutes = createRoutes(routesData);
  return cachedRoutes;
};

// For backward compatibility - provide a default empty routes array that gets populated
export const allRoutes: ItemRoute[] = [];

